import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { QuizManagementService } from '@edtech-ui/core/services/quiz-management/quiz-management.service';
import { ToastrService } from 'ngx-toastr';
import { CreateQuizPayload } from '@edtech-ui/core/models/quiz-creation/create-quiz';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';
import { ClassroomManagementService } from '@edtech-ui/core/services/classroom-management-service/classroom-management.service';
import { GetClassroomByTeacher, GetClassroomByTeacherResponse } from '@edtech-ui/core/models/Classroom/get-classroomByTeacher';
import { AddLinkDialogBoxComponent } from '@edtech-ui/dashboard/manual-course-creation/add-link-dialog-box/add-link-dialog-box.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileValidationService } from '@edtech-ui/core/services/file-validation/file-validation.service';
import { MaterialFileUpload } from '@edtech-ui/constants/material-file.enum';
import { AnnouncementService } from '@edtech-ui/core/services/announcement-management/announcement.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { DeleteDialogBoxComponent } from '../delete-dialog-box/delete-dialog-box.component';
import { PatchAnnouncementPayload } from '@edtech-ui/core/models/material-upload/announcement-patch-api';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StudyMaterialResponse, TopStudyMaterial } from '@edtech-ui/core/models/material-upload/get-all-study-material';

@Component({
	selector: 'app-classroom-overview',
	standalone: true,
	imports: [MatDialogModule, CommonModule, FormsModule, ReactiveFormsModule,
		MatTooltipModule, MatMenuModule, MatIconModule, MatProgressSpinnerModule
	],
	templateUrl: './classroom-overview.component.html',
	styleUrl: './classroom-overview.component.scss'
})
export class ClassroomOverviewComponent implements OnInit, OnDestroy {

	showCourseCreationModal = false;
	showModal = false;
	quizForm !: FormGroup;
	classroomId !:number;
	subscription = new Subscription();
	content: string = '';
	_classroom: GetClassroomByTeacher[] = [];
	selectedFilter: string = 'All';
	selectedClassroom: any[] = [];
	currentClassroomId: number = 1;
	isOpen = false;
	announcementForm!: FormGroup;
	links: string[] = [];
	uploadedImages: any[] = [];
	_MaterialFileUpload = MaterialFileUpload;
	currentPopup: number | null = null;
	editAnnouncementForm: FormGroup;
	isLoading: boolean = false;
	isAnnouncement: boolean = false;
	_topStudyMaterial: TopStudyMaterial[] = [];
	isCreating: boolean = false;

	@ViewChild('dropdownPopup') dropdownPopupRef!: ElementRef;
    @ViewChild('dropdownContainer') dropdownContainerRef!: ElementRef;

	constructor(private router: Router,
		private route: ActivatedRoute,
		private _quizService: QuizManagementService,
		private _toastr: ToastrService,
		private _dialog: MatDialog,
		private _classroomService: ClassroomManagementService,
		private _fileService: FileValidationService,
		private _announcementService: AnnouncementService,
	) {
		this.quizForm = new FormGroup({
			quiz_name: new FormControl('', Validators.required),
			hours: new FormControl(null, [Validators.min(0)]),
			minutes: new FormControl(null, [Validators.min(0), Validators.max(60), Validators.maxLength(2)]),
			seconds: new FormControl(null, [Validators.min(0), Validators.max(60), Validators.maxLength(2)]),
		});

		this.announcementForm = new FormGroup({
			content: new FormControl(null),
			files: new FormControl(null),
			website_urls: new FormControl(null)
		});

		this.editAnnouncementForm = new FormGroup({
			content: new FormControl('', Validators.required),
		});

		this.subscription.add(this._announcementService.reload$.pipe(tap(() => this.getAllStudyMaterialAnnouncement())).subscribe());
	}

	ngOnInit(): void {
		this.route.parent?.paramMap.subscribe((params) => {
			const classroomIdParams = params.get('id');
			if (classroomIdParams) {
				this.classroomId = +classroomIdParams;
				this.currentClassroomId = this.classroomId;
			}
		});
		this.getClassroom();
		this.getAllStudyMaterialAnnouncement();
	}

	closeModal(): void {
		this.showCourseCreationModal = false;
		this.showModal = false;
	}

	generateWithAI() {
		this.router.navigate(['../ai-creation'], { relativeTo: this.route });
	}

	goToCoursePage() {
		this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'course-creation-form']);
	}

	openModel(event?: MouseEvent): void {
		event?.stopPropagation();
		this.showModal = true;
	}

	createQuiz() {
		//const quizName = this.quizForm.get('quiz_name')?.value;
		// if (!this.classroomId) {
		// 	this._toastr.error('Classroom ID is missing');
		// 	return;
		// }
		// this.isCreating = true;

		// const hours = this.quizForm.get('hours')?.value || 0;
		// const minutes = this.quizForm.get('minutes')?.value || 0;
		// const seconds = this.quizForm.get('seconds')?.value || 0;

		// const timeLimit = (hours * 3600) + (minutes * 60) + seconds;
		// if (timeLimit === 0) {
		// 	this._toastr.error('Please set a time limit');
		// 	this.isCreating = false;
		// 	return;
		// }

		// const quizPayload: CreateQuizPayload = {
		// 	quiz_name: quizName,
		// 	time_limit: timeLimit,
		// }
		// this.subscription.add(
		// 	this._quizService.postCreateQuiz(quizPayload, this.classroomId, quizName, timeLimit).pipe(
		// 		tap(response => {
		// 			if (response.Success) {
		// 				this.router.navigate(['/teacher-dashboard/create-quiz', this.classroomId ,response.Data.quiz_id]);
		// 			} else {
		// 				this._toastr.error(response.Message);
		// 			}
		// 		}),
		// 		catchError(() => {
		// 			this.isCreating = false
		// 			this._toastr.error('Something went wrong while creating the quiz. Please try again.');
		// 			return of(null);
		// 		}),
		// 		finalize(()=>{this.isCreating = false })
		// 	).subscribe());as here not using this api for now
	}

	getClassroom() {
		const filterType = this.selectedFilter.toLowerCase();
		const page = 1;
		this.subscription.add(
			this._classroomService.getAllTeacherClassrooms(filterType, page).subscribe({
				next: (response: GetClassroomByTeacherResponse) => {
					this._classroom = response.Data.classrooms;
					if (this.currentClassroomId) {
						this.selectedClassroom = [this.currentClassroomId];
					} else if (this._classroom.length > 0) {
						this.selectedClassroom = [this._classroom[0].id]
					}
					this._classroom.sort((a, b) =>
						(this.selectedClassroom.includes(a.id) ? 0 : 1) - (this.selectedClassroom.includes(b.id) ? 0 : 1)
					);

				},
				error: () => {
					this._toastr.error('Failed to fetch classrooms.');
				}
			})
		);
	}

	onSelect(event: Event, id: number) {
		const checked = (event.target as HTMLInputElement).checked;
		if (checked) {
			if (!this.selectedClassroom.includes(id)) {
				this.selectedClassroom = [...this.selectedClassroom, id];
			}
		} else {
			this.selectedClassroom = this.selectedClassroom.filter(c => c !== id);
		}
	}

	toggleDropdown() {
		this.isOpen = !this.isOpen;
	}


	onFileSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		if (!input.files) return;

		const newFiles: File[] = Array.from(input.files);
		const currentFiles: File[] = this.announcementForm.value.files || [];
		const validFiles: File[] = [];

		newFiles.forEach(file => {

			const alreadyExists = [...currentFiles, ...validFiles].some(
				f => f.name === file.name && f.size === file.size);

			if (alreadyExists) {
				this._toastr.error(`File "${file.name}" is already added.`);
				return;
			}
			const { fileData, error } = this._fileService.processFileMaterial(file);
			if (error) {
				this._toastr.error(error);
				return;
			}

			if (fileData) {
				this.uploadedImages.push(fileData);
				validFiles.push(fileData.file);
			}
		});

		const updatedFiles = [...currentFiles, ...validFiles];
		this.announcementForm.patchValue({ files: updatedFiles });

		input.value = '';
	}

	removeImage(img: { file: File, website_url: string }) {
		this.uploadedImages = this.uploadedImages.filter(i => i !== img);
		const remainingFiles = this.announcementForm.value.files.filter(
			(f: File) => f !== img.file
		);
		this.announcementForm.patchValue({ files: remainingFiles });
	}

	removeUrl(index: number) {
		this.links.splice(index, 1);
		this.announcementForm.patchValue({ website_urls: this.links });
	}

	openAddLinkDialogBox(field: MaterialFileUpload) {
		const dialogRef = this._dialog.open(AddLinkDialogBoxComponent, {
			width: '400px'
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.links.push(result);
				this.announcementForm.patchValue({ website_urls: this.links });
			}
			if (field === MaterialFileUpload.URL) {
				this.links.push(result);
			}
		})
	}

	postShareMaterial(): void {

		if (this.announcementForm.invalid || !this.classroomId) return;

		const formData = new FormData();
		formData.append('owner_class_id', String(this.classroomId));
		const content: string = this.announcementForm.get('content')?.value || '';

		if (!this.announcementForm.value.files && !this.links.length && !content) {
			this._toastr.error('Please add content, file, or link before sharing.');
			return;
		}

		this.isLoading = true;

		const files: File[] = this.announcementForm.value.files || [];

		if (files.length) {
			files.forEach(file => formData.append('files', file));
		}

		if (this.links.length > 0) {
			formData.append('website_urls', this.links.length ? this.links.join(',') : JSON.stringify([]));
		}
		if (this.selectedClassroom && this.selectedClassroom.length > 0) {
			formData.append('class_ids', this.selectedClassroom.join(','));
		}
		if (content) formData.append('content', content);

		this._announcementService.postMaterial(formData).pipe(
			tap(response => {
				if (response.Success) {
					this._announcementService.announcementId.next(response.Data.id);
					this._toastr.success(response.Message);
					this.isOpen = false;
				} else {
					this._toastr.error(response.Message);
				}
			}),
			finalize(() => { this.isLoading = false; })
		).subscribe({
			next: () => {
				this.announcementForm.reset();
				this.uploadedImages = [];
				this.links = [];
				this.getAllStudyMaterialAnnouncement();
			}
		});

	}

	get selectedClassroomName(): string {
		if (this.selectedClassroom.length === 1) {
			const found = this._classroom.find(c => c.id === this.selectedClassroom[0]);
			return found?.name || '';
		}
		return `${this.selectedClassroom.length} classes`;
	}

	openDeleteDialogBox(announcementId: number) {
		this._dialog.open(DeleteDialogBoxComponent, {
			width: '360px',
			data: { announcementId }
		}).afterClosed().subscribe(result => {
			if (result == true) {
				this.deleteMaterialById(announcementId);
			}
		});
	}

	deleteMaterialById(announcementId: number) {
		this.subscription.add(
			this._announcementService.deleteMaterialById(announcementId).subscribe({
				next: () => {
					this._toastr.success('Announcement deleted successfully');
				}
			})
		);
	}

	getAllStudyMaterialAnnouncement() {
		this.isAnnouncement = true;
		if (!this.classroomId) {
			this._toastr.error('classroomId is missing');
			return;
		}
		this.subscription.add(
			this._announcementService.getAllStudyMaterialAnnouncement(this.classroomId).subscribe({
				next: (response: StudyMaterialResponse) => {
					this.isAnnouncement = false;
					this._topStudyMaterial = response.Data.top;
				},
				error: () => {
					this.isAnnouncement = false;
					this._toastr.error('Failed to load announcements');
					this._topStudyMaterial = [];
				}
			})
		);
	}

	openEditPopup(announcement: any) {
		this.currentPopup = announcement.id;
		this.editAnnouncementForm.patchValue({
			content: announcement.content
		});
	}

	closePopup(event?: Event) {
		if (event) {
			event.stopPropagation();
		}
		this.currentPopup = null;
		this.editAnnouncementForm.reset();
	}

	updateAnnouncement() {
		if (!this.currentPopup) return;

		const payload: PatchAnnouncementPayload = {
			announcement_content: this.editAnnouncementForm.value.content,
			announcement_id: this.currentPopup,
		}
		this.subscription.add(
			this._announcementService.updateAnnouncement(payload).pipe(
				tap(response => {
					if (response.Success) {
						this._toastr.success(response.Message);
					}else{
						this._toastr.error(response.Message)
					}
					catchError(() => {
						this._toastr.error('Something went wrong while updating');
						return of(null);
					})
				})).subscribe(() => {
					this.closePopup();
				})
		);
	}

	convertToIST(utcDateString: string): string {
		if (!utcDateString) return '';
		const date = new Date(utcDateString + 'Z');
		return new Intl.DateTimeFormat('en-IN', {
			timeZone: 'Asia/Kolkata',
			dateStyle: 'medium',
			timeStyle: 'short'
		}).format(date);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent) {
		const target = event.target as HTMLElement;
		if (
			this.isOpen &&
			this.dropdownPopupRef &&
			this.dropdownContainerRef &&
			!this.dropdownPopupRef.nativeElement.contains(target) &&
			!this.dropdownContainerRef.nativeElement.contains(target)
		) {
			this.isOpen = false;
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}